export const STACKED_BREAKPOINT = 'lg';
export const BORDER_WIDTH = '4px';

export const WHITE_10 = 'hsla(0, 100%, 100%, 0.1)';
export const WHITE_20 = 'hsla(0, 100%, 100%, 0.2)';

export const BLACK_10 = 'hsla(0, 0%, 0%, 0.1)';
export const BLACK_20 = 'hsla(0, 0%, 0%, 0.2)';
